import { render, staticRenderFns } from "./Extra.vue?vue&type=template&id=6316f0bc&scoped=true&"
import script from "./Extra.vue?vue&type=script&lang=js&"
export * from "./Extra.vue?vue&type=script&lang=js&"
import style0 from "./Extra.vue?vue&type=style&index=0&id=6316f0bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6316f0bc",
  null
  
)

export default component.exports